<template>
  <div>
    <v-parallax light src="/kim_background.jpg" height="600" min-height="500">
      <v-row align="start" align-content="start" justify="start" style="max-height: 200px;">
        <img src="KI-BIT_Logo_mit_Schriftzug_rechts.png" class="mx-3 my-3" alt="Logo" style="height:45px;" />
      </v-row>

      <v-row align="center" align-content="start" justify="center">
        <h1 class="login-page-claim mx-12">{{$ct('claimHeader')}}</h1>
        <p class="login-page-claim body-1 mx-12 mt-5">{{$ct('claimText')}}</p>
      </v-row>
    </v-parallax>

    <v-parallax dark src="/kim_splash_login.jpg" height="800">
      <div class="kipat-login-background-blur"></div>
      <v-container class="kipat-login-container">
        <v-row align="center" align-content="center" justify="center">
          <v-card :loading="loading" max-width="600">
            <v-card-title class="justify-center">{{$ct('personalizeTitle')}}</v-card-title>
            <v-card-text class="px-10"><p>
              {{$ct('personalizeDescription')}}
            </p></v-card-text>
            <v-card-text align="center">
              <v-form ref="form" v-model="valid" class="mx-10">
                <v-text-field v-model="code" :counter="getCounter()" :rules="codeRules" :label="$ct('runCode')" required></v-text-field>

                <div id="loginRecaptcha" class="g-recaptcha mt-5" ></div>

                <v-btn v-if="isCookiesAccepted" :disabled="!valid || (!recaptchaToken && !disableRecaptcha) || loading" color="primary" class="my-5" @click="personalize">
                  {{$ct('personalize')}}
                </v-btn>
                <v-btn v-else color="primary" class="my-5" @click="reload">
                  {{$ct('acceptCookies')}}
                </v-btn>

              </v-form>
            </v-card-text>
          </v-card>
        </v-row>
      </v-container>
    </v-parallax>

  </div>

</template>

<script>
import ACTIONS from '@/store/storeActions';
import { EventBus, EVENTS } from '@/libs/eventBus';

let reCaptchaInterval;

export default {
  name: 'LoginPage',
  components: {},
  data() {
    return {
      loading: false,
      recaptchaSiteKey: process.env.VUE_APP_RECAPTCHA,
      disableRecaptcha: process.env.VUE_APP_DISABLE_RECAPTCHA === 'true',
      valid: true,
      code: process.env.VUE_APP_RUNTOKEN,
      recaptchaToken: null,
      codeRules: [
        (v) => !!v || this.$i18n.t('LoginPage.validatorCodeIsRequired'),
        (v) => (v && v.length >= 6 && v.length <= 10) || this.$i18n.t('LoginPage.validatorCodeLength'),
      ],
      isCookiesAccepted: this.$cookies.get('gdpr') === 'true',
    };
  },
  methods: {
    verified(token) {
      console.log('recaptcha', token);
      this.recaptchaToken = token;
    },
    personalize() {
      this.$refs.form.validate();

      // Block the button
      this.loading = true;
      // get token and candidate
      this.$api.user
        .get({ token: this.code, recaptchaToken: this.recaptchaToken, type: 'candidate' })
        .finally(() => {
          this.loading = false
        })
    },
    reload() {
      this.$router.go();
    },
    recaptcha() {
      if (window.grecaptcha && window.grecaptcha.render && this.recaptchaSiteKey) {
        console.log('captcha render');
        const self = this;
        this.widgetId = window.grecaptcha.render('loginRecaptcha', {
          sitekey: self.recaptchaSiteKey,
          // size: 'invisible',
          // the callback executed when the user solve the recaptcha
          callback: (response) => {
            // emit an event called verify with the response as payload
            self.verified(response);
            // reset the recaptcha widget so you can execute it again
          },
        });
        clearInterval(reCaptchaInterval);
      } else {
        console.log('ReCaptcha not yet loaded');
      }
    },
    getCounter() {
      if (!this.code || ![7, 8, 9, 10].includes(this.code.length)) {
        return 6;
      }
      return this.code.length
    }
  },
  computed: {
  },
  mounted() {
    if (!this.disableRecaptcha) {
      reCaptchaInterval = setInterval(this.recaptcha, 500);
    }

    const self = this;
    EventBus.$on(EVENTS.SET_COOKIES, () => {
      self.isCookiesAccepted = self.$cookies.get('gdpr') === 'true';
    });

    // setTimeout(this.recaptcha, 1000);
  },
};
</script>

<style language="stylesheet/scss">
.login-page-claim{
  color:black!important;
}

</style>
